// Runtime-editable brand palette. Colors map to CSS variables (--ct-<key>)
// consumed by Tailwind (rgb(var(--ct-x) / <alpha-value>)).

export const THEME_COLORS = [
  { key: "pink", label: "Primary Pink", d: "#C9317D" },
  { key: "marigold", label: "Gold Accent", d: "#F2B632" },
  { key: "cocoa", label: "Deep Plum (nav)", d: "#2A1A22" },
  { key: "cocoadeep", label: "Darkest Plum (footer)", d: "#170E12" },
  { key: "pinkdeep", label: "Pink (deep)", d: "#9C2766" },
  { key: "terracotta", label: "Mango / Coral", d: "#E8603C" },
  { key: "turquoise", label: "Teal", d: "#17A99B" },
  { key: "chili", label: "Chili Red", d: "#C8322B" },
  { key: "purple", label: "Purple", d: "#7A2C8F" },
  { key: "magenta", label: "Rose Pink", d: "#FF5FA2" },
  { key: "agave", label: "Agave Green", d: "#5B8A5B" },
  { key: "cream", label: "Blush Cream Background", d: "#FFF8F5" },
  { key: "surface", label: "Card Surface", d: "#FFFFFF" },
  { key: "alt", label: "Alt Background", d: "#FCEDEE" },
  { key: "ink", label: "Ink / Body Text", d: "#2B1A22" },
  { key: "line", label: "Lines / Borders", d: "#F3D7DC" },
];

export const DEFAULT_THEME = THEME_COLORS.reduce((acc, c) => {
  acc[c.key] = c.d;
  return acc;
}, {});

// "Site chrome" colors stored as raw hex (no alpha modifiers needed).
export const CHROME_COLORS = [
  { key: "scrollbarTrack", label: "Scrollbar Track", d: "#FCEDEE" },
  { key: "scrollbarThumb", label: "Scrollbar Thumb", d: "#C9317D" },
  { key: "scrollbarThumbHover", label: "Scrollbar Thumb (hover)", d: "#F2B632" },
  { key: "selectionBg", label: "Text Selection", d: "#C9317D" },
  { key: "selectionText", label: "Selected Text", d: "#FFFFFF" },
];

CHROME_COLORS.forEach((c) => { DEFAULT_THEME[c.key] = c.d; });

const CHROME_VAR = {
  scrollbarTrack: "--ct-scrollbar-track",
  scrollbarThumb: "--ct-scrollbar-thumb",
  scrollbarThumbHover: "--ct-scrollbar-thumb-hover",
  selectionBg: "--ct-selection-bg",
  selectionText: "--ct-selection-text",
};

export const hexToChannels = (hex) => {
  if (!hex || typeof hex !== "string") return null;
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((x) => x + x).join("");
  if (h.length !== 6) return null;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return null;
  return `${r} ${g} ${b}`;
};

export const applyTheme = (theme = {}) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  THEME_COLORS.forEach(({ key, d }) => {
    const ch = hexToChannels(theme[key] || d);
    if (ch) root.style.setProperty(`--ct-${key}`, ch);
  });
  CHROME_COLORS.forEach(({ key, d }) => {
    root.style.setProperty(CHROME_VAR[key], theme[key] || d);
  });
};
